module.exports = __webpack_public_path__ + "static/media/SiteActiveTime.f940c6ce.png";